var map = {
	"./thumb1.webp": 31996,
	"./thumb2.webp": 32631,
	"./thumb3.webp": 79170,
	"./thumb4.webp": 9740,
	"./thumb5.webp": 16834,
	"./thumb6.webp": 76030,
	"./thumb7.webp": 81831,
	"./thumb8.webp": 31861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72151;